// extracted by mini-css-extract-plugin
module.exports = {"toc":"toc-module--toc--ESgSd","list":"toc-module--list--2Kp4K","title":"toc-module--title--2RiYi","fontsLoading":"toc-module--fonts-loading--qazhF"};